import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { resolveFeatureForPath } from '../../config/planFeatures';
import { useUserPlan } from '../../hooks/useUserPlan';

/** Link that still renders; Free users hitting Team/Pro routes see the upgrade screen. */
export default function PlanAwareLink({ to, children, onClick, ...rest }) {
  const navigate = useNavigate();
  const { planReady, canUseFeature } = useUserPlan();
  const path = typeof to === 'string' ? to : to?.pathname || '';

  const handleClick = (e) => {
    onClick?.(e);
    if (e.defaultPrevented) return;
    const feature = resolveFeatureForPath(path.split('?')[0]);
    if (feature && planReady && !canUseFeature(feature)) {
      e.preventDefault();
      navigate(path.split('?')[0]);
    }
  };

  return (
    <Link to={to} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
}
